import React , {useState , useRef} from 'react'
import { Typography , Chip , Tooltip , Grid } from '@mui/material';
import TableHeader from '../../shared/table/TableHeader'
import CustomTable from '../../shared/table/CustomTable'
import { useDispatch , useSelector } from 'react-redux';
const columnDefaults = {
    sortable: false,
    flex: 1,
    filterable: true,
    minWidth: 200,
  };
  
  const sentSuccess = 1
  const pending = 2
  
  /**
   * Required:
   
  1 is message genderated 
  2  is message pending
  0 is message failed
     */
  
  const defaultColumns = [
    {
      ...columnDefaults,
      field: "swiftRef",
      headerName: "SWIFT Ref",
      sortable:true
    },
    {
      ...columnDefaults,
      field: "swiftDate",
      headerName: "SWIFT Date",
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span className="table-cell-trucate">{params.value}</span>
        </Tooltip>
      ),
      sortable: true,
     
    },
   
    {
      ...columnDefaults,
      field: "generated",
      headerName: "Status",
      renderCell: (params) => (
        <Chip
        label={params?.value === sentSuccess ? "Sent" : params.value === pending ? "Pending" : "Failed"}
        sx={{
          height: "20px",
          borderRadius:"10px",
          width:"35%",
          backgroundColor:params.value === sentSuccess ? "#E5F6E4" : params.value === pending ? "#F7CB73" : "#FFD8D6"
        }}
        />
       ),
      sortable: true,
    },
    
    {
      ...columnDefaults,
      field: "messageType",
      headerName: "Message Type",
      sortable: true,
    },
    
    {
      ...columnDefaults,
      field: "inOut",
      headerName: "In/Out",
      sortable:true
    },

    {
        ...columnDefaults,
        field: "ssss",
        headerName: "Operator",
        sortable:true
      },
    
  ];
  
  const allColumns = [
    ...defaultColumns,
    {
      ...columnDefaults,
      field: "omniReceivers",
      headerName: "Waiting Time",
      renderCell: (params) => (
  <div>
  {params.value.map((value) => (
    <Typography>{value}</Typography>
  ))}
  </div>
        
      ),
      filterable:false
    },
  ];

  const persistColumns = (columns) => {
    localStorage.setItem(
      "MatchingColumns",
      JSON.stringify(columns.map((c) => c.field))
    );
    };
  
    const loadPersistentColumns = () => {
      const persistentColumns = JSON.parse(
        localStorage.getItem("MatchingColumns")
      );
      if (persistentColumns) {
        return allColumns
          .filter((c) => persistentColumns.includes(c.field))
          .sort(
            (a, b) =>
              persistentColumns.indexOf(a.field) -
              persistentColumns.indexOf(b.field)
          );
      }
      return defaultColumns;
    };
const MatchingDayList = ({data,error,success}) => {

    const {rows ,updatedAt , processing , pageSize , pageNumber , totalItems , totalPages}
    = useSelector((state) => state.matchingDay);
    const persistentColumns = loadPersistentColumns()
    const [tableRef, setTableRef] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [columns, setColumns] = useState(persistentColumns);
    const [anchorEl, setAnchorEl] = useState(null);
    const [viewRows, setViewRows] = useState([]);
    const dispatch = useDispatch()

/*   const onBeforeGetContentResolve = useRef(null); */
const customizationRef = useRef(null);
const onSelectionChange = (rows) => {
  setSelectedRows(rows);
};



const handleColumnsChange = (items) => {
  setColumns([...items]);
  persistColumns(items);
};

const handlePaginationChange = (paginationFilter) => {
//  dispatch(LoadSubscribers({
    // searchCriteria: { 
    //     from: format(new Date(data.from) , "yyyy-MM-dd HH:mm"),
    //     to: format(new Date(data.to) , "yyyy-MM-dd HH:mm"),
    //    },
//     pageNumber,
//     pageSize,
//     ...paginationFilter,
  
//  },
     
//     )
//   )
}; 

/* const handleOnBeforeGetContent = () => {
  return new Promise((resolve) => {
    togglePrint((show) => !show);
    onBeforeGetContentResolve.current = resolve;
  });
}; */


const handleShowColumns = () => {
  setAnchorEl(customizationRef.current);
};

const handleColumnHide = (field) => {
  const filteredColumns = columns.filter((column) => column.field !== field);
  setColumns([...filteredColumns]);
  persistColumns(filteredColumns);
};




const onRowClick = (row) => {
  setViewRows([row]);
 
};




/*   useEffect(() => {
  if (showPrint) onBeforeGetContentResolve.current();
}, [showPrint, onBeforeGetContentResolve]); */

const selectedRowsWithDetails = rows
  .filter((row, index) => selectedRows.includes(`${row.customerId}-${index}`))
  .map((row, index) => ({
    ...row,
    id: `${row.customerId}-${index}`,
      })); 

  return (
    <>
    <Grid
        container
        spacing={2}
        padding={3}
      >
        <Grid item xs={12}>
          <TableHeader
       defaultColumns={defaultColumns}
       allColumns={allColumns}
       inUseColumns={columns}
       numberOfRows={totalItems}
       numberOfSelectedRows={selectedRows.length}
       handleColumnsChange={handleColumnsChange}
       isPrint = {false}
       isMail = {false} 
      isActive = {true}
      isView = {false}
      isDeactive = {true}
      isAssgin={true}
       isHistory = {false}
       isReGenerate={false}
       handleViewMessages={() => {
        setViewRows(selectedRowsWithDetails);
        //setDrawer(true)
      }}
     
       handleUnselectAll={() => {
         setSelectedRows([]);
        
       }}
       {...{ anchorEl, setAnchorEl, handleShowColumns }}
          />
        </Grid>
        <Grid item xs={12} ref={(newTableRef) => setTableRef(newTableRef)}>
          <CustomTable
            {...{
              pageSize,
              pageNumber,
              totalItems,
              totalPages,
              columns,
              tableRef,
              updatedAt,
              loading: processing,
              onSelectionChange,
              selectedRows,
              onRowClick,
              handleColumnHide,
              onPaginationChange: handlePaginationChange,
            }}
            DynamicHeight ={() => 'auto'}
            rows={rows.map((row, index) => ({
                ...row,
                id: `${row.transactionId}-${index}`,
              }))}
          />
        </Grid>
      </Grid>

    </>
  )
}

export default MatchingDayList